import React, { SyntheticEvent } from 'react';
import Icon from '../../atoms/icon';
import Text from '../../atoms/text';
import { faShare } from '@fortawesome/pro-solid-svg-icons';
import AnchorButton from '../../molecules/button/anchor';
import { IPatient } from '../../../libs/patient';
import { useActiveDialogsUpdater } from '../../../contexts/active-dialogs';
import { GetPMTemplatesParams } from '../../../libs/pm';

/**
 * This action kicks off the
 * push message flow
 */

interface PushMessageActionProps {
  patient: IPatient;
  templateType: GetPMTemplatesParams['templateType'];
  useTemplate?: (data: string) => void;
}

export const PushMessageAction = ({
  patient,
  templateType,
  useTemplate
}: PushMessageActionProps): JSX.Element => {
  const addDialog = useActiveDialogsUpdater();
  const isChat = templateType === 'chat';
  const title = isChat ? 'Use Chat Template' : 'Push Message';

  const handleClick = (evt: SyntheticEvent) => {
    evt.stopPropagation();
    addDialog({
      id: `pushMessage${patient.id}`,
      name: 'PushMessage',
      payload: {
        patient,
        templateType,
        useTemplate
      }
    });
  };

  return (
    <AnchorButton
      className="justify-left"
      onClick={handleClick}
      fill
      variant="minimal"
    >
      {isChat ? null : <Icon className="mr-2" icon={faShare} title={title} />}
      <Text className={isChat ? 'mb-4 ml-3' : ''} dotted>
        <span role="status">{title}</span>
      </Text>
    </AnchorButton>
  );
};
